import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-cp-ivoire text-center" data-testid="not-found-page">
            <div className="max-w-xl">
                <p className="cp-kicker text-cp-foret mb-6">Page introuvable</p>
                <h1 className="cp-serif text-6xl md:text-7xl leading-tight text-cp-noir mb-6">Un secret mal rangé.</h1>
                <p className="text-cp-gris text-lg font-light mb-10">Cette page s'est évaporée dans la brume. Rejoignons la côte.</p>
                <Link to="/" className="cp-btn-primary">Retour à l'accueil</Link>
            </div>
        </div>
    );
}
